import React, { Component } from 'react';
import { MyContext, MyHeading, MyGlobal } from '../components/GlobalContext';

export class Warehouse extends Component {
    static displayName = Warehouse.name;

    constructor(props) {
        super(props);
        this.state = { data: [], loading: true, labelText:"Select a Warehouse"};
        this.history = props.history;

    }
  
    componentDidMount() {
        document.title = MyGlobal.pageTitle = "Choose Warehouse";
        this.populateWarehouse();
    }

    rowClicked(e, key, context) {
        //   
        this.history.push("MainMenu");
    }

    renderTable(data) {
        return (
            <MyContext.Consumer>
                {context => (
                    <table className='table table-striped' aria-labelledby="tabelLabel">
                        <thead>
                            <tr>
                                <th>Warehouse</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map(row =>
                                <tr key={row.whS_ID}
                                    onClick={() => {
                                        MyGlobal.warehouse = row.whS_ID;
                                        MyGlobal.warehouse_name = row.name
                                        this.rowClicked();
                                    }}>
                                    <td>{row.name}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
                </MyContext.Consumer>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderTable(this.state.data);

        return (
            <div>
                <MyHeading>{this.state.labelText}</MyHeading>
               {contents}
            </div>

        );
    }

    async populateWarehouse() {
        //   const token = await authService.getAccessToken();
        const response = await fetch('api/warehouse/warehouses', {
            //      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        this.setState({ data: data, loading: false });
    }
}
